import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionId } from 'vopay';
import useZelle from '@/hooks/useApi/useZelle';
import ZelleTransactionInfo from './ZelleTransactionInfo';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type ZelleTransactionContainerProps = TransactionId & { fullName: string; jwt: string; ELinxRequestID?: string } & Omit<
    ComponentProps<typeof ZelleTransactionInfo>,
    'transaction'
  >;

export default function ZelleTransactionContainer({
  TransactionID,
  fullName,
  jwt,
  ELinxRequestID = '',
  ...props
}: ZelleTransactionContainerProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { fetchZelleWithdrawTransaction, transaction } = useZelle({ bearer: jwt });

  useEffect(() => {
    blockingLoader.show();

    fetchZelleWithdrawTransaction(TransactionID)
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  return (
    <div>
      {transaction && (
        <ZelleTransactionInfo
          transaction={transaction}
          fullName={fullName}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
